import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/client';
import { endpoints } from '@/shared/api/endpoints';
import { getEndpoint } from '@/shared/utils/getUrl';
import type { AssetsList } from '@/entities/assets/types';
import type { ScanConfigurationsList } from '@/entities/scans/types';

export const useTourAssetsQuery = (companyId: string, enabled: boolean) =>
  useQuery({
    queryKey: ['onboarding', 'asset-count', companyId],
    enabled: Boolean(companyId) && enabled,
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<AssetsList>(
        getEndpoint(endpoints.assets.list, { page: 1, limit: 1 }).replace(
          '__COMPANY__',
          encodeURIComponent(companyId)
        ),
        { signal }
      );
      if (typeof data.total_count !== 'number') throw new Error('Invalid asset count');
      return data.total_count;
    },
    staleTime: 10_000,
    retry: 1,
  });

export const useTourScheduleQuery = (companyId: string, enabled: boolean) =>
  useQuery({
    queryKey: ['onboarding', 'schedule', companyId],
    enabled: Boolean(companyId) && enabled,
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<ScanConfigurationsList>(
        getEndpoint(endpoints.scanConfigurations.list, {
          company_id: companyId,
          is_active: true,
          limit: 100,
        }),
        { signal }
      );
      if (!Array.isArray(data.data)) throw new Error('Invalid scan configurations');
      return (
        data.data.find((config) => config.is_active && Boolean(config.schedule?.trim())) ?? null
      );
    },
    staleTime: 30_000,
    retry: 1,
  });
